import { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BsFillCartCheckFill, BsFillCartPlusFill } from "react-icons/bs";
import CartContext from "../../context/CartContext";
import SearchContext from "../../context/SearchContext";
import { useProductFilter } from "../../context/ProductFilterContext";
import { Spinner } from "react-bootstrap";
import "./productcard.css";
import Carrossel from "../Carrossel";
import BannerCarousel from "../BannerCarousel";
import BannerMarcas from "../BannerMarcas";
import ProductCatalog from "../ProductCatalog";
import Destaques from "../Destaques";

const formatImageUrl = (url) => {
  if (!url) return "";
  return url.replace("/media/", "/api/media/");
};
function calcularDesconto25(preco) {
  return preco * 0.25;
}

const formatPrice = (price) => {
  const precoNumerico = Number(price);
  if (isNaN(precoNumerico)) return "Preço inválido";

  const precoComDesconto = precoNumerico + calcularDesconto25(precoNumerico);

  return precoComDesconto.toLocaleString("pt-AO", {
    style: "currency",
    currency: "AOA",
    minimumFractionDigits: 2,
  });
};

// Função para embaralhar array (Fisher-Yates algorithm)
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const ProductCard = ({ products }) => {
  const { cart, addToCart, removeFromCart } = useContext(CartContext);
  const { searchTerm } = useContext(SearchContext);
  const { filterCategory, filterSubcategory, setFilterCategory, setFilterSubcategory } = useProductFilter();
  const [loading, setLoading] = useState(true);
  const [visibleProducts, setVisibleProducts] = useState(8);
  const [shuffledProducts, setShuffledProducts] = useState([]);

  const productsRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (!location.state?.scrollToProducts) {
      setFilterCategory("");
      setFilterSubcategory("");
    }
  }, [location, setFilterCategory, setFilterSubcategory]);

  // Embaralha os produtos quando eles são carregados ou mudam
  useEffect(() => {
    if (products.length > 0) {
      setShuffledProducts(shuffleArray(products));
    }
  }, [products]);

  const filteredProducts = shuffledProducts.filter((product) => {
    const matchCategory = filterCategory ? product.categoria_nome === filterCategory : true;
    const matchSubcategory = filterSubcategory ? product.subcategoria_nome === filterSubcategory : true;
    const matchSearch = searchTerm ? product.descricao.toLowerCase().includes(searchTerm.toLowerCase()) : true;
    return matchCategory && matchSubcategory && matchSearch;
  });

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (
      (searchTerm || filterCategory || filterSubcategory) &&
      productsRef.current &&
      filteredProducts.length > 0
    ) {
      setTimeout(() => {
        productsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [searchTerm, filterCategory, filterSubcategory, filteredProducts]);

  const handleLoadMore = () => {
    setVisibleProducts((prev) => prev + 6);
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" role="status" />
        <p className="mt-3">Carregando produtos, por favor aguarde...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="section-spacing">
        <Carrossel />
        <div ref={productsRef} id="products-section"></div>
      </div>
     <div>

     </div>

      <div className="row g-4" style={{ margin: "0 auto", maxWidth: "1200px" }}>
        {filteredProducts.length > 0 ? (
          filteredProducts.slice(0, visibleProducts).map((product) => {
            const isInCart = cart.some((item) => item.id === product.id);

            return (
              <div key={product.id} className="product-card">
                <img src={formatImageUrl(product.imagem)} alt={product.descricao} />
                <h3>{product.descricao}</h3>
                <p className="card-text">Codigo: {product.codigo}</p>
                
                {/* Preço com acréscimo de 25% */}
                <p>Preço: {formatPrice(product.preco_com_iva)}</p>
                
                <p
                  className="card-stock"
                  style={{ color: product.stock?.toLowerCase() !== "indisponível" ? "green" : "red" }}
                >
                  STOCK: {product.stock?.toLowerCase()}
                </p>

                <button
                  className="cart-icon-button"
                  onClick={() => (isInCart ? removeFromCart(product.id) : addToCart(product))}
                  title={isInCart ? "Remover do Carrinho" : "Adicionar ao Carrinho"}
                >
                  {isInCart ? (
                    <BsFillCartCheckFill size={24} color="green" />
                  ) : (
                    <BsFillCartPlusFill size={24} color="gray" />
                  )}
                </button>

                <Link to={`/product/${product.id}`} className="btn btn-primary custom-btn">
                  Ver Detalhes
                </Link>
              </div>
            );
          })
        ) : (
          <div className="text-center w-100">
            <>
                <span className="spinner"></span> Aguarde mais um pouco...
              </>
          </div>
        )}
      </div>

      {visibleProducts < filteredProducts.length && (
        <div className="text-center mt-4">
          <button className="btn btn-outline-primary" onClick={handleLoadMore}>
            Ver mais
          </button>
        </div>
      )}

      <div className="text-center mt-4">
        <BannerCarousel />
        <BannerMarcas />
      </div>
    </div>
  );
};

export default ProductCard;